import React from 'react';
import Button from '@/components/Button';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  eligibleCandidateCount: number;
  isSubmitting: boolean;
};

const RetriggerJobNotificationsModal = ({
  isOpen,
  onClose,
  onConfirm,
  eligibleCandidateCount,
  isSubmitting,
}: Props) => {
  if (!isOpen) return null;

  const handleCancel = () => {
    if (isSubmitting) return;
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 px-4 py-8 sm:px-6">
      <div
        className="w-full max-w-lg rounded-lg bg-white p-6 shadow-xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="retrigger-job-notifications-title"
      >
        <h3
          id="retrigger-job-notifications-title"
          className="text-xl font-bold text-gray-800"
        >
          Retrigger Job Notifications?
        </h3>
        <p className="mt-3 text-sm text-gray-700">
          This will send a new job notification to {eligibleCandidateCount}{' '}
          eligible candidates. Are you sure you want to continue?
        </p>

        <div className="mt-6 flex justify-end gap-3">
          <Button
            variant="outline"
            type="button"
            onClick={handleCancel}
            disabled={isSubmitting}
            className="py-2 text-sm"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            type="button"
            onClick={onConfirm}
            disabled={isSubmitting}
            className="py-2 text-sm"
          >
            {isSubmitting ? 'Retriggering...' : 'Retrigger notifications'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RetriggerJobNotificationsModal;
